module.exports = __webpack_public_path__ + "static/media/books.fed7c13e.svg";